import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import * as S from "./tag.style";
export var Tag = function(param) {
    var children = param.children, _variant = param.variant, variant = _variant === void 0 ? "white" : _variant, _type = param.type, type = _type === void 0 ? "default" : _type, _isSelected = param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, onClick = param.onClick;
    // Externally initialized
    var ref = useState(isSelected), isActive = ref[0], setIsActive = ref[1];
    // Internally handled
    var ref1 = useState(false), isHover = ref1[0], setIsHover = ref1[1];
    var handleClick = function() {
        setIsActive(!isActive);
        if (onClick) {
            onClick();
        }
    };
    return /*#__PURE__*/ _jsx(S.Li, {
        variant: variant,
        type: type,
        isSelected: isActive,
        isHover: isHover,
        onClick: handleClick,
        onMouseEnter: function() {
            return setIsHover(true);
        },
        onMouseLeave: function() {
            return setIsHover(false);
        },
        children: children
    });
};
